"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTransCustomerFeedbackAggreatorServiceClient = exports.initCustomClient = exports.getTransCustomerFeedbackAggreatorServiceClient = exports["default"] = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _coral_comAmazonTransFeedbackTcfaModelV = require("@amzn/coral_com-amazon-trans-feedback-tcfa-model-v-1");
var _coralConfig_transCustomerFeedbackAggreatorServiceLambda = require("@amzn/coral-config_trans-customer-feedback-aggreator-service-lambda");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _GetDisplayableFeedbackQuestionnaireResponse = _interopRequireDefault(require("../models/GetDisplayableFeedbackQuestionnaireResponse"));
var _SubmitFeedbackRequest = _interopRequireDefault(require("../models/SubmitFeedbackRequest"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** @typedef {import("@amzn/ihm-js-coral-client").CoralClientConfigFactory} CoralClientConfigFactory */
/** @typedef {import("@amzn/ihm-js-coral-client").CoralInterceptor} CoralInterceptor */
var transCustomerFeedbackAggreatorServiceClient = null;

/**
 * Initialize the TransCustomerFeedbackAggreatorServiceLambda client
 *
 * @param {string} env - String env
 * @param {CoralInterceptor} requestOptionsInterceptor - Interceptor
 */
var initTransCustomerFeedbackAggreatorServiceClient = exports.initTransCustomerFeedbackAggreatorServiceClient = function initTransCustomerFeedbackAggreatorServiceClient(env, requestOptionsInterceptor) {
  var clientFactory = new _ihmJsCoralClient.CoralClientFactory([_coralConfig_transCustomerFeedbackAggreatorServiceLambda.TransCustomerFeedbackAggreatorServiceLambdaClientConfigFactory], env, new _ihmJsCoralClient.InterceptingHandler(new _ihmJsCoralClient.CoralFetchHandler(), [_coral_comAmazonTransFeedbackTcfaModelV.transCustomerFeedbackAggreatorServiceLambdaHttpBindingInterceptor, requestOptionsInterceptor]));

  /**
   * Custom web server to override serialization/deserialization
   */
  var CustomTransCustomerFeedbackAggreatorServiceLambda = /*#__PURE__*/function (_TransCustomerFeedbac) {
    (0, _inherits2["default"])(CustomTransCustomerFeedbackAggreatorServiceLambda, _TransCustomerFeedbac);
    var _super = _createSuper(CustomTransCustomerFeedbackAggreatorServiceLambda);
    function CustomTransCustomerFeedbackAggreatorServiceLambda(config, handler) {
      var _this;
      (0, _classCallCheck2["default"])(this, CustomTransCustomerFeedbackAggreatorServiceLambda);
      _this = _super.call(this, config, handler);
      _this.handler.handlerChain.interceptor.operations.GetDisplayableFeedbackQuestionnaire.deserializationFn = _GetDisplayableFeedbackQuestionnaireResponse["default"].fromJson;
      _this.handler.handlerChain.interceptor.operations.SubmitFeedback.serializationFn = _SubmitFeedbackRequest["default"].toJson;
      return _this;
    }
    return (0, _createClass2["default"])(CustomTransCustomerFeedbackAggreatorServiceLambda);
  }(_coral_comAmazonTransFeedbackTcfaModelV.TransCustomerFeedbackAggreatorServiceLambda);
  transCustomerFeedbackAggreatorServiceClient = clientFactory.get(CustomTransCustomerFeedbackAggreatorServiceLambda);
};
var initCustomClient = exports.initCustomClient = function initCustomClient(client) {
  transCustomerFeedbackAggreatorServiceClient = client;
};

/**
 * Get the TransCustomerFeedbackAggreatorServiceLambda client if it has been initialized
 *
 * @returns {TransCustomerFeedbackAggreatorServiceLambda}
 */
var getTransCustomerFeedbackAggreatorServiceClient = exports.getTransCustomerFeedbackAggreatorServiceClient = function getTransCustomerFeedbackAggreatorServiceClient() {
  if (!transCustomerFeedbackAggreatorServiceClient) {
    throw new Error('TransCustomerFeedbackAggreatorServiceClient not initialized');
  }
  return transCustomerFeedbackAggreatorServiceClient;
};
var _default = exports["default"] = {
  initTransCustomerFeedbackAggreatorServiceClient: initTransCustomerFeedbackAggreatorServiceClient,
  getTransCustomerFeedbackAggreatorServiceClient: getTransCustomerFeedbackAggreatorServiceClient
};
//# sourceMappingURL=TransCustomerFeedbackAggreatorServiceClient.js.map